import { HorizontalContainer, VerticalContainer } from '@/components';
import { AttachmentIcon } from '@/components/Icons';
import { AttachmentsList } from '@/hooks/upload-files';
import { FileEntity } from '@/shared/interfaces';

import { R } from '@/caregiverSpace/resources/Texts.resx';

type AttachmentsProps = {
    attachments: FileEntity[];
    onRemoveCallback?: (identifier: string) => void;
    small?: boolean;
};

export const Attachments = ({
    attachments,
    onRemoveCallback,
    small = true,
}: AttachmentsProps) => {
    if (!attachments || attachments.length === 0) {
        return null;
    }

    return (
        <VerticalContainer spacing="md">
            <HorizontalContainer spacing="xs">
                <AttachmentIcon variant="default" />
                <span className="flex h-full items-center">
                    {R.Attachments}
                </span>
            </HorizontalContainer>
            <AttachmentsList
                files={attachments}
                className="flex-nowrap"
                onRemoveCallback={onRemoveCallback}
                small={small}
            />
        </VerticalContainer>
    );
};
